<template>
  <div>
    <h1
      class="kbx-title"
      klickbox-edit-item="welcome-title"
      :klickbox-edit-label="$t('edit.canvas.welcome_title')"
      :style="stepStyle('welcome-title')">
      <text-editor
        :content="stepPreview.title"
        :change="onChange"
        :toolbar="true"
        :placeholder="$t('edit.canvas.welcome_title')"></text-editor>
    </h1>
  </div>
</template>

<script>
import TextEditor from 'src/components/general/TextEditor/Main';
import { mapGetters } from 'vuex';

export default {
  components: {
    TextEditor,
  },
  computed: mapGetters({
    stepStyle: 'stepStyle',
    stepPreview: 'stepPreview',
  }),
  methods: {
    onChange(text) {
      this.$store.dispatch('stepUpdateTitle', {
        event: { target: { value: text } },
        id: this.stepPreview.id,
      });
    },
  },
};
</script>



/** WEBPACK FOOTER **
 ** Title.vue?22334da0
 **/